import * as ajax from '@/helpers/ajax';
import { logger } from '@/helpers/logger';
import { useQuery } from 'react-query';
import { JobPosting } from '../../page-templates/JobDetailsPage/interfaces';
import assetPath from '../../uikit/helpers/assetPath';
import { JOBS__DATA_PATH } from './consts';

export const getJobs = async (): Promise<JobPosting[]> => {
  try {
    const results =
      (await ajax.getJsonCached<JobPosting[]>(
        `${assetPath}${JOBS__DATA_PATH}`
      )) ?? [];

    return results;
  } catch (error) {
    logger.log('getJobs', error);
    return [];
  }
};
export default function useJobs() {
  return useQuery('jobs', getJobs);
}
